import { render, staticRenderFns } from "./TabelaIndice.vue?vue&type=template&id=5e0c59ac&scoped=true&"
import script from "./TabelaIndice.vue?vue&type=script&lang=js&"
export * from "./TabelaIndice.vue?vue&type=script&lang=js&"
import style0 from "./TabelaIndice.vue?vue&type=style&index=0&id=5e0c59ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c59ac",
  null
  
)

export default component.exports